import { ConcreteEncodable } from "./ConcreteEncodable";

import { PositionBookImplEncoder } from "../../encoder/PositionBookImplEncoder";

import * as CubiqTS from "../../index";
import { PositionBook } from "../PositionBook";

export class PositionBookImpl extends ConcreteEncodable implements PositionBook {
  public static enType: string = "com.bcdfx.model.PositionBookImpl";

  /*FID=1*/
  public positionBookId: CubiqTS.Long | null = null;
  /*FID=2*/
  public positionBookName: string;
  /*FID=3*/
  public positionBookBranch: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PositionBookImplEncoder.Instance;
    this.setEncodableType(PositionBookImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PositionBookImpl[" +
      "positionBookId=" +
      this.positionBookId +
      "positionBookName=" +
      this.positionBookName +
      "positionBookBranch=" +
      this.positionBookBranch +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
